import React from 'react';
import {Box} from '@mui/material';
import {Icon} from '@lightricks/react-design-system';
import {IRREGULAR_ICON_SIZE} from '../constants';

// Fullscreen Toggle Component
interface FullscreenToggleProps {
  isFullscreen: boolean;
  onToggleFullscreen: (event: React.MouseEvent<HTMLDivElement>) => void;
  color: string;
}

function FullscreenToggle({
  isFullscreen,
  onToggleFullscreen,
  color,
}: FullscreenToggleProps) {
  return (
    <Box
      onClick={onToggleFullscreen}
      style={{
        marginLeft: '8px',
        cursor: 'pointer',
      }}
    >
      <Icon
        name={
          isFullscreen ? 'Actions-Fullscreen-Exit' : 'Actions-Fullscreen-Enter'
        }
        size="medium"
        appearance="neutral"
        color={color}
        style={{
          width: `${IRREGULAR_ICON_SIZE}px`,
          height: `${IRREGULAR_ICON_SIZE}px`,
        }}
      />
    </Box>
  );
}

export default FullscreenToggle;
